export default {
  getAppTitle(): string {
    return process.env.VUE_APP_TITLE ? process.env.VUE_APP_TITLE : 'ClearGlass';
  },

  getApiUrl(): string {
    return process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '';
  }
};
